import { bottomChromeHeightAtom, FLOATING_CHROME_GAP, supportButtonFootprintAtom } from "@/atoms/bottom-chrome"
import { Button, Icon } from "@/components/ui"
import { APP_SHELL_WIDTH } from "@/components/ui/FixedFooter"
import { CHROME_Z_INDEX } from "@/contexts/ModalContext"
import type { PrizeGameKind } from "@/domain/marketing/prize-game"
import { cn } from "@/lib/cn"
import { Gift } from "@/icons"
import { useAtomValue } from "jotai"

type PrizeGameChipProps = { kind: PrizeGameKind; onOpen: () => void }

/** Floating "Raspe e ganhe" / "Gire e ganhe" entry point while the customer has not played, opposite the support button. */
export function PrizeGameChip({ kind, onOpen }: PrizeGameChipProps) {
  const bottomChrome = useAtomValue(bottomChromeHeightAtom)
  const support = useAtomValue(supportButtonFootprintAtom)
  const side = support?.side === "left" ? "right" : "left"

  return (
    <div
      style={{ zIndex: CHROME_Z_INDEX.bar, bottom: bottomChrome + FLOATING_CHROME_GAP }}
      className="pointer-events-none fixed left-0 right-0 transition-[bottom] duration-slow ease-standard"
    >
      <div className={cn("mx-auto flex px-4", APP_SHELL_WIDTH, side === "left" ? "justify-start" : "justify-end")}>
        <Button
          size="sm"
          shape="pill"
          elevation="raised"
          onClick={onOpen}
          aria-haspopup="dialog"
          className="pointer-events-auto hover:scale-105 motion-reduce:hover:scale-100"
        >
          <Icon as={Gift} size="sm" weight="fill" />
          {kind === "wheel" ? "Gire e ganhe" : "Raspe e ganhe"}
        </Button>
      </div>
    </div>
  )
}
